import { render } from "./IrrdDetails.vue?vue&type=template&id=28cb137c&scoped=true"
import script from "./IrrdDetails.vue?vue&type=script&lang=js"
export * from "./IrrdDetails.vue?vue&type=script&lang=js"

import "./IrrdDetails.vue?vue&type=style&index=0&id=28cb137c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28cb137c"]])

export default __exports__